import { useEffect } from 'react'

const GTM_CONTAINER_ID_REGEX = /^GTM-[A-Z0-9]{6,8}$/

export default function useGtmInjector(containerId: string | undefined) {
  useEffect(() => {
    if (!containerId) return
    if (!GTM_CONTAINER_ID_REGEX.test(containerId)) {
      console.error('GTM container id em formato inválido, injeção abortada')
      return
    }

    const scriptId = `gtm-tenant-${containerId}`
    if (document.getElementById(scriptId)) return

    const script = document.createElement('script')
    script.id = scriptId
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${containerId}');
    `
    document.head.appendChild(script)

    const noscriptId = `gtm-noscript-${containerId}`
    if (!document.getElementById(noscriptId)) {
      const noscript = document.createElement('noscript')
      noscript.id = noscriptId
      const iframe = document.createElement('iframe')
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`
      iframe.height = '0'
      iframe.width = '0'
      iframe.style.display = 'none'
      iframe.style.visibility = 'hidden'
      noscript.appendChild(iframe)
      document.body.insertBefore(noscript, document.body.firstChild)
    }

    return () => {
      const existingScript = document.getElementById(scriptId)
      if (existingScript) existingScript.remove()
      const existingNoscript = document.getElementById(noscriptId)
      if (existingNoscript) existingNoscript.remove()
    }
  }, [containerId])
}
